var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "128px",
    height: "128px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "12.4850481%",
    y1: "17.6360531%",
    x2: "93.3022677%",
    y2: "75.9905533%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F95EA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C3FB9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comparison",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loading-indicator",
    transform: "translate(-61.000000, -41.000000)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.369587,41.0010447 C125.684198,41.0028237 125.998271,41.0068728 126.311791,41.0131763 C127.794791,41.1495462 130,42.2714588 130,46 C130,50 115.004567,51.9984775 109,54 C103,56 91,62 83,71 C75,80 72,93 72,106 C72,119 76.692635,131.598777 89,144 C100.073143,155.15759 110,158 126,158 C129.373311,158 149.962257,155.975388 163,144 C176.037743,132.024612 178,114.604019 178,105 C178,89.1805903 169,70 167,68 C165.295774,66.2957736 165.50661,63.4933896 166,63 C168,61 169.969845,60.589047 172.484923,62.2945235 C172.684181,62.4296408 172.910275,62.6164015 173.159297,62.8502831 C174.798583,64.719459 176.329606,66.6859792 177.743844,68.7391651 C180.373408,72.7407305 183.230785,78.0020274 185,83 C187.678909,90.567825 188.917868,98.5954531 188.996041,104.417173 L189,105 C189,140.346224 160.346224,169 125,169 L125.304793,168.996878 C121.304496,168.960898 116.35249,168.60451 110.913017,167.443051 C82.34333,161.026706 61,135.505854 61,105 L61.0028358,105.305457 C61.0281029,102.221311 61.2254714,98.871924 61.7247738,95.3456168 C65.38869,71.1229737 82.6299531,51.3551011 105.446387,44.042134 C113.392241,41.6492778 120.560971,41.0665342 125.158161,41.0056215 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIndicator);
export default __webpack_public_path__ + "static/media/loading-indicator.956a98ad5c3370a88f05382faa5d8e8d.svg";
export { ForwardRef as ReactComponent };